import { render } from "./index.vue?vue&type=template&id=bf82f5d6&scoped=true&bindings={}"
import script from "./account-info.js?vue&type=script&lang=js"
export * from "./account-info.js?vue&type=script&lang=js"

import "./account-info.scss?vue&type=style&index=0&id=bf82f5d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf82f5d6"

export default script